<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Boundless></Boundless>

      <Advantages></Advantages>

      <TypeDiv></TypeDiv>

      <ServicesType></ServicesType>

      <Portfolio></Portfolio>

      <Const></Const>

  </div>
</template>

<script>
import Banner from '../../components/MobileDevelopment/CrossPlatformDevelopment/Banner.vue'
import ServicesType from '../../components/MobileDevelopment/IosDevelopment/ServicesType.vue'
import Advantages from '../../components/MobileDevelopment/CrossPlatformDevelopment/Advantages.vue'
import Boundless from '../../components/MobileDevelopment/CrossPlatformDevelopment/Boundless.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/MobileDevelopment/CrossPlatformDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        Boundless,
        TypeDiv,
        Advantages,
        Portfolio,
        Const,
        ServicesType
    }
}
</script>


<style>

</style>